export const PLANS_RESET_STATE = 'PLANS_RESET_STATE';
export const PLANS_CURRENT_ITEM = 'PLANS_CURRENT_ITEM';

export const PLANS_REQUEST_LOADING = 'PLANS_REQUEST_LOADING';
export const PLANS_REQUEST_SUCCESS = 'PLANS_REQUEST_SUCCESS';
export const PLANS_REQUEST_FAILED = 'PLANS_REQUEST_FAILED';

export const PLANS_CURRENT_ACTION = 'PLANS_CURRENT_ACTION';
export const PLANS_RESET_ACTION = 'PLANS_RESET_ACTION';
